import React, { useEffect } from "react";
import "./WhatWeOffer.css";

import img1 from "../../assets/images/service1.png";
import img2 from "../../assets/images/service2.png";
import img3 from "../../assets/images/service3.png";
import img4 from "../../assets/images/service4.png";
import img5 from "../../assets/images/service5.png";
import img6 from "../../assets/images/service6.png";
import img7 from "../../assets/images/service7.png";
import img8 from "../../assets/images/service8.png";
import img9 from "../../assets/images/service9.png";

import person1 from "../../assets/images/person1.jpg";
import person2 from "../../assets/images/person2.jpg";
import person3 from "../../assets/images/person3.jpg";
import person4 from "../../assets/images/person4.jpg";


const services = [
  {
    img: img1,
    title: "App Development",
    desc: "At NMD INFO-TECH SERVICES, we’re excited to expand our portfolio with Custom App Development solutions tailored to meet the dynamic needs of modern businesses.",
    link: "/services/app-development"

  },
  {
    img: img2,
    title: "Game Development",
    desc: "Powering the Future of Gaming As the global gaming industry continues to thrive, we're excited to bring our passion for storytelling, technology, and innovation into the world of game development.",
    link: "/services/game-development"
  },
  {
    img: img3,
    title: "Digital Marketing",
    desc: "At NMD Infotech Services, we provide comprehensive digital marketing solutions designed to help businesses thrive in the digital age. ",
    link: "/services/digital-marketing"
  },
  {
    img: img4,
    title: "Data Science/Analytics",
    desc: "In today’s digital age, data isn’t just numbers—it’s knowledge, insight, and opportunity. That’s why we’re thrilled to introduce Data Science Services at NMD Info Tech Services.",
    link: "/services/data-science"
  },
  {
    img: img5,
    title: "Business Consulting",
    desc: "As organizations navigate an ever-changing business landscape, our commitment to providing comprehensive solutions is underscored by the introduction of strategic business consulting.",
    link: "/services/business-consulting"
  },
  {
    img: img6,
    title: "Data Analysis",
    desc: "At NMD Info Tech Services, we know that smart decisions start with the right insights. That’s why we’re thrilled to introduce our Data Analysis Services—a major leap in our commitment to providing you with comprehensive, results-driven solutions.",
    link: "/services/data-analysis"
  },
  // {
  //   img: img7,
  //   title: "Cloud Services",
  //   desc: "From cloud infrastructure setup to server management, we provide end-to-end cloud services using platforms like AWS and Firebase. We ensure data security, scalability, and cost-effective cloud computing.",
  //   link: "/services/data-analysis"
  // },
  // {
  //   img: img8,
  //   title: "Business Consulting",
  //   desc: "Navigate the complexities of the business landscape with our strategic Business Consulting services. Our experts deliver tailored strategies to streamline operations, boost performance, and drive long-term growth.",
  //   link: "/services/business-consulting"
  // },
  // {
  //   img: img9,
  //   title: "Digital Marketing Services",
  //   desc: "At NMD Infotech Services, we deliver customized digital marketing solutions to help businesses grow and thrive in the digital age, ensuring that you remain competitive and adapt to the fast-paced technological landscape.",
  //   link: "/services/digital-marketing"
  // }
];

const WhatWeOffer = () => {

  // 👇 SCROLL ANIMATION ADDED
  useEffect(() => {
    const elements = document.querySelectorAll(".scroll-anim");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          } else {
            entry.target.classList.remove("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="offer-section">

      <div className="offer-heading scroll-anim">
        <h2>What We Offer</h2>
        <div className="scroll-line"></div>
        <p>Your trusted partner for modern digital solutions</p>
      </div>

      <div className="offer-grid">
        {services.map((srv, i) => (
          <div className="offer-card scroll-anim" key={i}>
            <img src={srv.img} alt={srv.title} />
            <h3>{srv.title}</h3>
            <p>{srv.desc}</p>
            <a href={srv.link} className="offer-btn">Learn More</a>
          </div>
        ))}
      </div>

      <div className="trust-badge">
  <div className="trust-avatars">
    <img src={person1} alt="user1" />
    <img src={person2} alt="user2" />
    <img src={person3} alt="user3" />
    <img src={person4} alt="user4" />
  </div>

  <p>
    Trusted by <span>50,000+ businesses</span> to scale outbound sales
  </p>
</div>
    </section>
  );
};

export default WhatWeOffer;
